import { object, string } from 'yup';

export const signInValidation = () =>
  object().shape({
    email: string().required('Email is required'),
    password: string().required('Password is required')
  });

export const signInDefaults = () => ({
  email: '',
  password: ''
});
